import { Outlet, Link, NavLink, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Bars3Icon } from '@heroicons/react/24/outline';
import { api } from '@/utils/api';

type Category = { id: string; name: string; slug: string };

export function AppLayout() {
  const [open, setOpen] = useState(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    // Track page view (daily aggregate)
    (async () => {
      try { await api.post('/api/public/track', { path: location.pathname }); } catch {}
    })();
    let ignore = false;
    (async () => {
      try {
        const res = await api.get('/api/public/categories');
        if (!ignore) setCategories(res.categories ?? []);
      } catch {
        // Sessizce başarısız ol
      }
    })();
    return () => {
      ignore = true;
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="sticky top-0 z-40 bg-white/90 backdrop-blur border-b border-gray-200">
        <div className="max-w-none px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between gap-12 md:gap-16 py-4">
            <Link to="/" className="flex items-center gap-3">
              <Logo />
              <div className="leading-tight">
                <div className="font-bold text-lg">Edirne Süleyman Demirel Fen Lisesi | ESDFL</div>
              </div>
            </Link>
            <nav className="hidden md:flex flex-1 flex-wrap items-center justify-center gap-x-6 gap-y-2">
              <NavLink to="/" className={({ isActive }) => isActive ? 'text-brand-700 font-semibold' : 'text-gray-700 hover:text-gray-900'}>
                En Son
              </NavLink>
              {categories.map((c) => (
                <NavLink key={c.id} to={`/kategori/${c.slug}`} className={({ isActive }) => isActive ? 'text-brand-700 font-semibold' : 'text-gray-700 hover:text-gray-900'}>
                  {c.name}
                </NavLink>
              ))}
            </nav>
            <button onClick={() => setOpen((v) => !v)} className="md:hidden btn-secondary" aria-label="Menü">
              <Bars3Icon className="h-5 w-5" />
            </button>
          </div>
          {open && (
            <div className="md:hidden border-t border-gray-200 py-2">
              <div className="flex flex-col gap-2 py-2">
                <NavLink to="/" className={({ isActive }) => (isActive ? 'text-brand-700 font-semibold' : 'text-gray-700 hover:text-gray-900') + ' px-1 py-1'}>
                  En Son
                </NavLink>
                {categories.map((c) => (
                  <NavLink key={c.id} to={`/kategori/${c.slug}`} className={({ isActive }) => (isActive ? 'text-brand-700 font-semibold' : 'text-gray-700 hover:text-gray-900') + ' px-1 py-1'}>
                    {c.name}
                  </NavLink>
                ))}
              </div>
            </div>
          )}
        </div>
      </header>
      <main className="mx-auto max-w-[144rem] px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-gray-200 bg-white">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-6 text-sm text-gray-600 flex items-center justify-center">
          <span>© {new Date().getFullYear()} ESDFL</span>
        </div>
      </footer>
    </div>
  );
}

function Logo() {
  return (
    <img src="https://esdfl.net/esdfl.png" alt="ESDFL" className="h-10 w-10 rounded" />
  );
}


